// extracted by mini-css-extract-plugin
module.exports = {"flexIt":"style__flexIt__nkTE2"};